import { makeStyles } from '@mui/styles';
import { defaultIcon } from '../../default';

const useStyles = makeStyles({
  beehive: {
    ...defaultIcon,
    '&:after, &:before': {
      top: '-.35em',
      width: '50%',
      left: '50%',
      transform: 'translate(-50%)',
    },
    '&:after': {
      top: 'auto',
      bottom: '-.35em',
    },
  },
  hamburger: {
    ...defaultIcon,
    '&:after, &:before': {
      top: '-.35em',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    '&:after': {
      top: 'auto',
      bottom: '-.35em',
    },
  },
  hamburgerAlt: {
    ...defaultIcon,
    '&:after, &:before': {
      top: '-.35em',
      left: 0,
      width: '50%',
      transform: 'unset',
    },
    '&:after': {
      top: 'auto',
      left: 'auto',
      bottom: '-.35em',
      right: 0,
    },
  },
  hamburgerAltReverse: {
    ...defaultIcon,
    '&:after, &:before': {
      top: '-.35em',
      right: 0,
      width: '50%',
      transform: 'unset',
    },
    '&:after': {
      top: 'auto',
      left: 0,
      bottom: '-.35em',
      right: 'auto',
    },
  },
});

export default useStyles;
